module.exports = __webpack_public_path__ + "img/b32eb81.png";